import BackofficeOperationDataTable from '../utils/BackofficeOperationDataTable';
import Rails from '@rails/ujs';

export default class BackofficeIndexBase {
  constructor(dataTableSelector, options = {}) {
    this.dataTableSelector = dataTableSelector;
    this.loaderSelector = options.loaderSelector || `${dataTableSelector.replace('-datatable', '')}-loader`;
    this.stepParamName = options.stepParamName || 'step';
    this.savedFiltersBannerId = options.savedFiltersBannerId || 'saved-filters-banner';
    this.saveFiltersButtonId = options.saveFiltersButtonId;
    this.clearFiltersButtonId = options.clearFiltersButtonId;
    this.saveStepButtonId = options.saveStepButtonId || 'saveOrderStep';

    this.dataTable = new BackofficeOperationDataTable(dataTableSelector);

    this.bindBaseEvents();
  }

  bindBaseEvents() {
    this.bindDuplicateButton();
  }

  bindDuplicateButton() {
    $('.duplicate-btn').on('click', function() {
      const orderId = $(this).data('id');
      const form = $('#duplicateForm');
      let actionUrl = form.attr('action');

      if (!actionUrl.includes('?id=')) {
        actionUrl += '?id=' + orderId;
        form.attr('action', actionUrl);
      }
    });
  }

  // Save step preference (order_step or study_request_step)
  bindSaveStepButton() {
    const $saveButton = $(`#${this.saveStepButtonId}`);
    if ($saveButton.length === 0) {
      return;
    }

    $saveButton.on('click', (event) => {
      event.preventDefault();

      const url = $saveButton.data('url');

      Rails.ajax({
        url,
        type: 'PUT',
        dataType: 'json',
        success: () => {
          application.successNotification("Filtre sauvegardé");
          $saveButton.addClass('disabled');
        },
        error: () => {
          application.errorNotification("Erreur lors de la sauvegarde du filtre");
        }
      });
    });
  }

  // Step dropdown handler (for order_step or study_request_step)
  bindStepDropdown(stepParamName, datatableId, loaderId) {
    const $dropdownLinks = $(`.dropdown-menu a[href*="${stepParamName}"]`);

    $dropdownLinks.on('click', (event) => {
      event.preventDefault();

      const $link = $(event.currentTarget);
      const url = new URL($link.attr('href'), globalThis.location.origin);
      const step = url.searchParams.get(stepParamName);

      const camelCaseStep = stepParamName.replaceAll(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      $(datatableId).data(camelCaseStep, step);
      $(loaderId).show();

      this.dataTable.reloadTable();

      globalThis.history.pushState({}, '', url.pathname + url.search);

      const $btnGroup = $link.closest('.btn-group');
      $btnGroup.find('.dropdown-toggle').text($link.text());
    });
  }

  // Filter form submission
  bindFilterForm(loaderId) {
    const $filterForm = $('#filter-form');
    if ($filterForm.length === 0) {
      return;
    }

    $filterForm.on('submit', (event) => {
      event.preventDefault();

      const formData = new FormData($filterForm[0]);
      const params = new URLSearchParams(formData);

      const newUrl = `${globalThis.location.pathname}?${params.toString()}`;
      globalThis.history.pushState({}, '', newUrl);

      $(loaderId).show();

      this.dataTable.reloadTable();

      $('#filterModal').modal('hide');

      $('#filter-form-submit .spinner-border').addClass('d-none');
      $('#filter-form-submit').prop('disabled', false);
    });
  }

  // Save filters button
  bindSaveFiltersButton(buttonId, clearButtonId) {
    const $saveFiltersButton = $(`#${buttonId}`);
    if ($saveFiltersButton.length === 0) {
      return;
    }

    $saveFiltersButton.on('click', (event) => {
      event.preventDefault();

      const url = $saveFiltersButton.data('url');
      const filters = this.collectFormFilters();

      if (Object.keys(filters).length === 0) {
        application.errorNotification('Aucun filtre à sauvegarder');
        return;
      }

      this.persistFilterPreferences(url, filters, {
        onSuccess: () => {
          this.updateSavedFiltersIndicator({ hasFilters: true, applied: false });

          $(`#${clearButtonId}`).removeClass('d-none');
          $('#filterModal').modal('hide');
          $('#filter-form').trigger('submit');
        }
      });
    });
  }

  // Clear filters button
  bindClearFiltersButton(buttonId) {
    const $clearFiltersButton = $(`#${buttonId}`);
    if ($clearFiltersButton.length === 0) {
      return;
    }

    $clearFiltersButton.on('click', (event) => {
      event.preventDefault();

      const url = $clearFiltersButton.data('url');

      this.persistFilterPreferences(url, {}, {
        onSuccess: () => {
          this.updateSavedFiltersIndicator({ hasFilters: false });

          $clearFiltersButton.addClass('d-none');
          $('#filterModal').modal('hide');

          const resetUrl = new URL(globalThis.location.href);
          resetUrl.searchParams.delete('skip_saved_filters');
          globalThis.history.replaceState({}, '', resetUrl.pathname + resetUrl.search);

          const $filterForm = $('#filter-form');
          $filterForm[0].reset();

          $('.select-multiple').val(null).trigger('change');

          $filterForm.trigger('submit');
        }
      });
    });
  }

  // Collect filters from form
  collectFormFilters() {
    const $form = $('#filter-form');
    if ($form.length === 0) {
      return {};
    }

    const formData = new FormData($form[0]);
    const filters = {};
    const ignoredKeys = new Set(['authenticity_token', 'utf8', 'commit']);

    for (const [key, value] of formData.entries()) {
      this.processFilterEntry(filters, key, value, ignoredKeys);
    }

    return filters;
  }

  processFilterEntry(filters, key, value, ignoredKeys) {
    const normalizedKey = key.endsWith('[]') ? key.slice(0, -2) : key;

    if (ignoredKeys.has(normalizedKey)) {
      return;
    }

    const trimmed = this.normalizeFilterValue(value);
    if (trimmed === null) {
      return;
    }

    this.addFilterValue(filters, normalizedKey, trimmed);
  }

  normalizeFilterValue(value) {
    if (value === undefined || value === null) {
      return null;
    }

    const trimmed = typeof value === 'string' ? value.trim() : value;
    return trimmed === '' ? null : trimmed;
  }

  addFilterValue(filters, key, value) {
    if (!Object.hasOwn(filters, key)) {
      filters[key] = value;
      return;
    }

    const current = filters[key];
    filters[key] = Array.isArray(current) ? [...current, value] : [current, value];
  }

  // Persist filter preferences via AJAX
  persistFilterPreferences(url, filters, options = {}) {
    if (!url) {
      application.errorNotification("URL de sauvegarde des filtres manquante");
      return;
    }

    const formData = this.buildFilterFormData(filters);

    Rails.ajax({
      url,
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: (response = {}) => {
        const cleared = response.cleared === true;
        const message = cleared ? 'Filtres sauvegardés supprimés' : 'Filtres sauvegardés';
        application.successNotification(message);

        if (options.onSuccess) {
          options.onSuccess(response);
        }
      },
      error: () => {
        application.errorNotification('Erreur lors de la sauvegarde des filtres');
      }
    });
  }

  buildFilterFormData(filters) {
    const formData = new FormData();

    for (const [key, value] of Object.entries(filters)) {
      if (Array.isArray(value)) {
        for (const item of value) {
          formData.append(`filters[${key}][]`, item);
        }
      } else {
        formData.append(`filters[${key}]`, value);
      }
    }

    return formData;
  }

  // Update the saved filters indicator banner
  updateSavedFiltersIndicator({ hasFilters, applied = false }) {
    const $bannerContainer = $('.page-title-box .align-items-center');
    const $existingBanner = $(`#${this.savedFiltersBannerId}`);

    if (hasFilters) {
      const message = applied
        ? 'Filtres sauvegardés appliqués automatiquement.'
        : 'Filtres sauvegardés disponibles.';

      if ($existingBanner.length > 0) {
        $existingBanner.html(`<i class="mdi mdi-content-save"></i> ${message}`);
      } else if ($bannerContainer.length > 0) {
        const $banner = $('<span>', {
          id: this.savedFiltersBannerId,
          class: 'fs-12 text-dark mt-1 d-block',
          html: `<i class="mdi mdi-content-save"></i> ${message}`
        });
        $bannerContainer.append($banner);
      }
    } else if ($existingBanner.length > 0) {
      $existingBanner.remove();
    }
  }

  onDataChanged() {
    // Override in subclasses for custom logic
  }

  onDestroy() {
    this.dataTable.onDestroy();
  }
}